module.exports = __webpack_public_path__ + "static/media/05.c3291384.jpg";